<section class="related-initiatives">
  <header class="related-initiatives__header mb-0 mb-md-4">
    <span class="type-body-md text-secondary fw-bold w-100">{{ subtitle || ('gerelateerde-initiatieven-subtitel' | fromDictionary) }}</span>
    <h1 class="related-initiatives__title h2 text-primary">{{ title || ('gerelateerde-initiatieven-titel' | fromDictionary) }}</h1>
    <a [routerLink]="['/initiatieven']" class="button button-link button--primary related-initiatives__more">
      <span>{{ 'gerelateerde-initiatieven-alle-initiatieven-link-titel' | fromDictionary }}</span>
      <app-icon anchor="icon-arrow-right"></app-icon>
    </a>
  </header>

  <main class="related-initiatives__main py-2 py-md-4" *ngIf="initiatives?.length">
    <!--<app-slider [cursorArrow]="false" [total]="initiatives.length" [config]="sliderConfig">
      <div class="col-12 col-md-6 col-lg-4" *ngFor="let initiative of initiatives">
        <app-initiative-card [inverted]="true" [initiative]="initiative"></app-initiative-card>
      </div>
    </app-slider>-->

    <app-slider-v2>
      <swiper-slide class="swiper-slide" *ngFor="let initiative of initiatives">
        <app-initiative-card class="swiper-slide__card" [inverted]="true" [initiative]="initiative"></app-initiative-card>
      </swiper-slide>
    </app-slider-v2>
  </main>
</section>
